"use client";

import { NormalText } from "@/components/text/NormalText";
import { WarningResourceCard } from "@/components/warning/WarningResourceCard";
import { numberOfMixedModelsFree } from "@/constants/payment";
import { numberOfCustomModelsFree } from "@/constants/payment";
import { UserNoDates } from "@/types/types";
import { getFormattedTimeLeft } from "@/utils/time/getFormattedTimeLeft";

export function ResourceCards({
  user,
  numberOfModels,
  numberOfMixedModels,
  className,
}: {
  user: UserNoDates;
  numberOfModels: number;
  numberOfMixedModels: number;
  className?: string;
}) {
  const numberOfCustomModelsLocked = Math.max(
    0,
    numberOfModels - numberOfCustomModelsFree
  );

  // null mean the user has unlimited conversion minutes
  const conversionTimeSecondsLost = user.conversionTimeLeftSeconds;

  const numberOfMixedModelsLocked = Math.max(
    0,
    numberOfMixedModels - numberOfMixedModelsFree
  );

  return (
    <div className={className}>
      <WarningResourceCard className="mb-4">
        {conversionTimeSecondsLost === null ?
          <NormalText elementType="p">
            You'll lose your conversion time.
          </NormalText>
        : <div className="flex justify-between gap-x-4">
            <NormalText elementType="p">Conversion time lost:</NormalText>

            <NormalText elementType="p" className="text-red-600">
              {getFormattedTimeLeft(conversionTimeSecondsLost)}
            </NormalText>
          </div>
        }
      </WarningResourceCard>

      <WarningResourceCard className="mb-4">
        {numberOfCustomModelsLocked === 0 ?
          <NormalText elementType="p">
            You'll lose access to your custom voice model slots.
          </NormalText>
        : <div className="flex justify-between gap-x-4">
            <NormalText elementType="p">Custom voice models locked:</NormalText>

            <NormalText elementType="p" className="text-red-600">
              {numberOfCustomModelsLocked}
            </NormalText>
          </div>
        }
      </WarningResourceCard>

      {numberOfMixedModelsLocked > 0 && (
        <WarningResourceCard>
          <div className="flex justify-between gap-x-4">
            <NormalText elementType="p">Mixed voices locked:</NormalText>

            <NormalText elementType="p" className="text-red-600">
              {numberOfMixedModelsLocked}
            </NormalText>
          </div>
        </WarningResourceCard>
      )}
    </div>
  );
}
